import { useState, useMemo } from 'react';
import {
  Box,
  Card,
  TextField,
  // Autocomplete,
  Stack,
  Button,
} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

export default function Filter({ empresas, vendedores, onChange }) {
  const [dataInicial, setDataInicial] = useState(
    dayjs()
    // .subtract(30, 'day')
  );
  const [dataFinal, setDataFinal] = useState(dayjs());
  // eslint-disable-next-line
  const [empresasSelecionadas, setEmpresasSelecionadas] = useState(empresas);
  // eslint-disable-next-line
  const [vendedoresSelecionados, setVendedoresSelecionados] = useState(vendedores);

  // const empresasOrdenadas = useMemo(() => {
  //   return [...empresas].sort((a, b) => a.nome.localeCompare(b.nome));
  // }, [empresas]);

  // const vendedoresFiltrados = useMemo(() => {
  //   if (empresasSelecionadas.length === 0) return [];
  //   const empresasIds = empresasSelecionadas.map((e) => e.id);
  //   return vendedores
  //     .filter((v) => empresasIds.includes(v.empresaId))
  //     .sort((a, b) => a.nome.localeCompare(b.nome));
  // }, [empresasSelecionadas, vendedores]);

  const empresasSelecionadasOrdenadas = useMemo(() => {
    return [...empresasSelecionadas].sort((a, b) => a.nome.localeCompare(b.nome));
  }, [empresasSelecionadas]);

  const vendedoresSelecionadosOrdenados = useMemo(() => {
    return [...vendedoresSelecionados].sort((a, b) => a.nome.localeCompare(b.nome));
  }, [vendedoresSelecionados]);

  // const handleEmpresasChange = (_, novasEmpresasSelecionadas) => {
  //   setEmpresasSelecionadas(novasEmpresasSelecionadas);

  //   const novasEmpresaIds = novasEmpresasSelecionadas.map((e) => e.id);

  //   const novosVendedores = vendedores.filter((v) =>
  //     novasEmpresaIds.includes(v.empresaId)
  //   );

  //   setVendedoresSelecionados(novosVendedores);
  // };

  const handleAplicarFiltro = () => {
    if (onChange) {
      onChange({
        dataInicial,
        dataFinal,
        empresasSelecionadas: empresasSelecionadasOrdenadas,
        vendedoresSelecionados: vendedoresSelecionadosOrdenados,
      });
    }
  };

  return (
    <Card sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Box p={2} sx={{ width: '100%' }}>
        {/* <Typography variant="h6" mb={2}>
          Filtros
        </Typography> */}

        <Stack
          direction="row"
          spacing={2}
          flexWrap="wrap"
          alignItems="flex-start"
          sx={{ width: '100%' }}
        >
          <DatePicker
            label="Data Inicial"
            value={dataInicial}
            onChange={(newValue) => setDataInicial(newValue)}
            renderInput={(params) => (
              <TextField {...params} sx={{ minWidth: 160, flex: 1 }} />
            )}
          />

          <DatePicker
            label="Data Final"
            value={dataFinal}
            onChange={(newValue) => setDataFinal(newValue)}
            renderInput={(params) => (
              <TextField {...params} sx={{ minWidth: 160, flex: 1 }} />
            )}
          />

          {/* <Autocomplete
            multiple
            options={empresasOrdenadas}
            getOptionLabel={(option) => option.nome}
            value={empresasSelecionadasOrdenadas}
            onChange={handleEmpresasChange}
            renderInput={(params) => (
              <TextField {...params} label="Empresa(s)" />
            )}
            disableCloseOnSelect
            sx={{
              minWidth: 200,
              flex: 1,
              '& .MuiAutocomplete-inputRoot': {
                maxHeight: '72px',
                overflowY: 'auto',
              },
              '& .MuiAutocomplete-tag': {
                maxWidth: '100%',
              },
            }}
          /> */}

          {/* <Autocomplete
            multiple
            options={vendedoresFiltrados}
            getOptionLabel={(option) => option.nome}
            value={vendedoresSelecionadosOrdenados}
            onChange={(_, newValue) => setVendedoresSelecionados(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Vendedor(es)"
                placeholder={
                  empresasSelecionadas.length === 0
                    ? 'Selecione uma empresa primeiro'
                    : 'Selecione vendedor(es)'
                }
              />
            )}
            disableCloseOnSelect
            disabled={empresasSelecionadas.length === 0}
            sx={{
              minWidth: 200,
              flex: 1,
              '& .MuiAutocomplete-inputRoot': {
                maxHeight: '72px',
                overflowY: 'auto',
              },
              '& .MuiAutocomplete-tag': {
                maxWidth: '100%',
              },
            }}
          /> */}

          <Button
            variant="contained"
            onClick={handleAplicarFiltro}
            startIcon={<FilterAltIcon />}
            sx={{ height: 56 }}
          >
            {/* Filtrar */}
          </Button>
        </Stack>
      </Box>
    </Card>
  );
}
